export default "__VITE_ASSET__B$9IqLM6__"